import {createFileRoute} from '@tanstack/react-router';
import UpgradeToTeamPage from '@features/upgrade-to-team/page';

export const Route = createFileRoute('/upgrade-to-team')({
  component: UpgradeToTeamPage,
});
